var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-wrapper',{staticClass:"head"},[_c('app-inner',{staticClass:"head-inner",attrs:{"row":true}},[(!_vm.window.is.mobile)?_c('com-social'):_vm._e(),_c('com-logo'),_c('com-menu')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }